/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import CommonToast from "../../../../components/_utils/CommonToast";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import Loader from "../../../../components/Loader/Index";
import ScheduleBeneficiaryTransactionViewAllCard from "../../../../components/Transactions/ScheduleBeneficiaryTransaction/ScheduleBeneficiaryTransactionViewAllCard/index.jsx";
import { getAllBeneficiaryAccounts } from "../../../../redux/features/accounts/beneficiaryAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";
import { ownerAccountsViewAll } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { getAllCategories } from "../../../../redux/features/sharedResources/sharedResources";
import {
  scheduledBeneficiaryViewAll,
  scheduledBeneficiaryAddLabel,
  scheduledBeneficiaryRemoveLabel,
} from "../../../../redux/features/transactions/scheduleBeneficiaryTransactions/index.js";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";
import useMultiSelect from "../../../../utils/useMultiSelect";
import UseHandleScroll from "../../../../hooks/useHandleScroll";

const ScheduleBeneficiaryTransactionViewSchedules = ({
  isPopup,
  type,
  payload,
  closeCallback,
  duplicateFilters,
  txnLabel,
  onClose,
  txnPayLoad: createPayload,
}) => {
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const isCreateFlow = type === "beneficiaryScheduleCreateTxn";
  const dupFilters = duplicateFilters;

  const isPopupMode = [
    "category",
    "history",
    "scheduleAcc",
    "confidential",
    "ScheduleAccBeneAcc",
    "beneficiaryScheduleCreateTxn",
  ].includes(type);

  const defaults = {
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptions[0],
  };

  const {
    searchParam: urlSearchParam,
    handleSearchParams: urlHandleSearchParams,
    handleClearSearchParam: urlHandleClearSearchParam,
  } = useCustomSearchParams(defaults);

  const searchParam = isPopupMode
    ? new URLSearchParams(defaults)
    : urlSearchParam;
  const handleSearchParams = isPopupMode ? () => {} : urlHandleSearchParams;
  const handleClearSearchParam = isPopupMode
    ? () => {}
    : urlHandleClearSearchParam;
  const dispatch = useDispatch();
  const clearButtonRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const [active, setActive] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [inputData, setInputData] = useState([]);

  const [loadingData, setLoadingData] = useState(false);

  const [isCardHovered, setIsCardHovered] = useState(false);

  const [accumulatedData, setAccumulatedData] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [beneScheduleLoading, setBeneScheduleLoading] = useState(false);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [searchdata, setSearchData] = useState(searchParam.get("search") || "");
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName:
      type === "history" || type === "confidential"
        ? payload.name
        : type === "scheduleAcc" || type === "ScheduleAccBeneAcc"
          ? payload?.schedule_acc_name
          : "",
    bankAccountNo:
      type === "history" ||
      type === "confidential" ||
      type === "scheduleAcc" ||
      type === "ScheduleAccBeneAcc"
        ? payload.number
        : type === "scheduleAcc" || type === "ScheduleAccBeneAcc"
          ? payload?.bank_acc_no
          : "",
  });

  const [txnAmountFilter, setTxnAmountFilter] = useState(
    isCreateFlow ? dupFilters.amount || "" : searchParam.get("amount") || "",
  );
  const [accountName, setAccountName] = useState(
    isCreateFlow
      ? createPayload?.bankAccountName || ""
      : txnPayLoad?.bankAccountName || "",
  );
  const [accountNameValue, setAccountNameValue] = useState("");
  const [accountNumber, setAccountNumber] = useState(
    isCreateFlow
      ? createPayload?.ownerBankAccountNo || ""
      : txnPayLoad?.bankAccountNo || "",
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [initCategoryFilter, setInitCategoryFilter] = useState(
    type === "category"
      ? payload?.category_id
      : searchParam.get("category") || "",
  );
  const [displayCategory, setDisplayCategory] = useState(
    type === "category"
      ? payload?.category_name
      : searchParam.get("dispCategory") || "",
  );
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [currentStatus, setCurrentStatus] = useState(
    type === "scheduleAcc" || type === "ScheduleAccBeneAcc"
      ? "pending"
      : searchParam.get("lifecycle") || "",
  );
  const [isPaymentMethod, setIsPaymentMethod] = useState(
    isCreateFlow
      ? dupFilters.payment_method || ""
      : searchParam.get("paymentmethod") || "",
  );
  const [startDate, setStartDate] = useState(
    searchParam.get("startDate")
      ? new Date(searchParam.get("startDate")) || ""
      : "",
  );
  const [endDate, setEndDate] = useState(
    searchParam.get("endDate")
      ? new Date(searchParam.get("endDate")) || ""
      : "",
  );
  const [startDateFilter, setStartDateFilter] = useState(
    searchParam.get("startDate")
      ? new Date(searchParam.get("startDate")) || ""
      : "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    searchParam.get("endDate")
      ? new Date(searchParam.get("endDate")) || ""
      : "",
  );
  const [frequencyMethod, setFrequencyMethod] = useState(
    searchParam.get("frequency") || "",
  );
  const [ownerAccountName, setOwnerAccountName] = useState(
    isCreateFlow
      ? dupFilters.owner_account_id || ""
      : searchParam.get("sourceAcc") || "",
  );
  const [destinationAccountName, setDestinationAccountName] = useState(
    isCreateFlow
      ? dupFilters.beneficiary_account_id || ""
      : type === "history" || type === "confidential"
        ? payload.id
        : type === "scheduleAcc" || type === "ScheduleAccBeneAcc"
          ? payload?.schedule_acc_id
          : searchParam.get("beneAcc") || "",
  );
  const [confidentialMethod, setConfidentialMethod] = useState(
    type === "confidential" ? "Show only confidential" : "",
  );
  const [confidentialMethodFilter, setConfidentialMethodFilter] = useState(
    isCreateFlow
      ? dupFilters.confidential_transaction || ""
      : type === "confidential"
        ? "Show only confidential"
        : searchParam.get("confidential") || "",
  );

  const categories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  const {
    handleChange,
    handleSelectAll: handleMultiSelectAll,
    handleSingleSelect,
  } = useMultiSelect();

  const [isLabelClicked, setIsLabelClicked] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [labels, setLabels] = useState([]);
  const [labelTransactions, setLabelTransactions] = useState([]);
  const [labelsFilter, setFilterLabels] = useState(
    searchParam.get("label")?.split(",") || txnLabel?.split(",") || [],
  );
  const labelActionDispatchedRef = useRef(false);

  const selectedCount = labelTransactions.length;

  const selectableTransactions = accumulatedData?.map((item) => ({
    ...item,
    id: item?.txn_id,
  }));
  const totalRecordCount = Number(mainData?.total_count || 0);

  const effectiveSelectCap =
    totalRecordCount > 0 && totalRecordCount <= Number(selectedValue)
      ? totalRecordCount
      : Number(selectedValue);

  const isAllSelected =
    labelTransactions?.length === effectiveSelectCap && effectiveSelectCap > 0;

  const handleSelectAll = () => {
    handleMultiSelectAll(
      labelTransactions,
      setLabelTransactions,
      selectedValue,
      selectableTransactions,
    );
  };

  const handleLabelTransactionSelect = (transaction) => {
    handleSingleSelect(labelTransactions, setLabelTransactions, selectedValue, {
      ...transaction,
      id: transaction?.txn_id,
    });
  };

  const handleCloseTxn = () => {
    setIsLabelPopupOpen(false);

    if (labelActionDispatchedRef.current) {
      handleAction();
      setLabelTransactions([]);
      setIsLabelClicked(false);
      labelActionDispatchedRef.current = false;
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload?.response?.data?.ids?.unsuccessful_ids?.[0]?.errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message;
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setBeneScheduleLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions)
      ?.map((item) => item?.id || item)
      ?.filter(Boolean);

    const res = await dispatch(
      scheduledBeneficiaryAddLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );

    if (scheduledBeneficiaryAddLabel?.fulfilled?.match(res)) {
      setLabels((prev) =>
        Array.from(new Set([...(prev || []), ...(labelsToAssign || [])])),
      );

      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      await handleAction();
      labelActionDispatchedRef.current = true;
    }

    if (scheduledBeneficiaryAddLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setBeneScheduleLoading(false);
    return scheduledBeneficiaryAddLabel?.fulfilled?.match(res);
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setBeneScheduleLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions)
      ?.map((item) => item?.id || item)
      ?.filter(Boolean);

    const res = await dispatch(
      scheduledBeneficiaryRemoveLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );

    if (scheduledBeneficiaryRemoveLabel?.fulfilled?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      await handleAction();
      labelActionDispatchedRef.current = true;
    }

    if (scheduledBeneficiaryRemoveLabel?.rejected?.match(res)) {
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: getErrorMessage(res),
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, 0);
    }

    setBeneScheduleLoading(false);
    return scheduledBeneficiaryRemoveLabel?.fulfilled?.match(res);
  };

  const [direction, setDirection] = useState("");
  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const { handleScroll } = UseHandleScroll(
    setDirection,
    lastScrollTop,
    GlobalConfiguration.beneSchTxnCardHeight,
  );

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const services = useSelector((state) => state.refreshToken.services);

  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };

  const handleCloseViewModal = (e) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    if (type === "labelsFlow") {
      onClose();
    }
    closeCallback?.call();
  };

  const handleSelect = (value) => {
    setDirection("");
    if (selectedValue === value) return;
    handleSubmit("pagesize", value);
    if (isLabelClicked && labelTransactions?.length > Number(value)) {
      handleChange(
        labelTransactions,
        setLabelTransactions,
        value,
        labelTransactions,
      );
    }
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    // setAccumulatedData([]);
    toggleDropdown();
  };

  const formatDate = (date) => {
    const day = String(date?.getDate())?.padStart(2, "0");
    const month = String(date?.getMonth() + 1)?.padStart(2, "0");
    const year = date?.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const fetchScheduleViewAllData = async () => {
    setLoadingData(true);

    let response;
    let data = [];

    try {
      switch (active) {
        case "Category":
          response = await dispatch(
            getAllCategories({ search_string: searchUserTextDebounce }),
          );
          data =
            response?.payload?.categories?.map((itm) => ({
              id: itm.id,
              Category: itm.name,
              Description: itm?.description || "Not given",
            })) || [];
          break;

        case "Beneficiary account":
          response = await dispatch(
            getAllBeneficiaryAccounts({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.beneficiary_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
                Contact_number: itm.contact_no,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;
        case "search":
          if (searchUserTextDebounce === "") {
            setSearchData("");
          } else {
            setSearchData(searchUserTextDebounce);
          }
          setBeneScheduleLoading(false);
          break;

        case "Owner account":
          response = await dispatch(
            ownerAccountsViewAll({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;
        case "Search":
          setSearchData(searchUserTextDebounce);
          setLoadingData(false);

          break;

        // NEW: labels dropdown source
        case "Labels":
          data =
            labels
              ?.filter((itm) => itm.includes(searchUserTextDebounce))
              ?.map((val) => ({ id: val, Label: val })) || [];
          break;

        default:
          data = [];
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      setInputData([...data]);
      setLoadingData(false);
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchScheduleViewAllData();
    }
  }, [active]);

  const FREQUENCY_MAP = {
    "Once": "once",
    "Daily": "daily",
    "Weekly": "weekly",
    "Fortnightly": "fortnightly",
    "Monthly": "monthly",
    "Quarterly": "quarterly",
    "Half yearly": "half_yearly",
    "Yearly": "yearly",
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const handlePagination = (page) => {
    setDirection("");
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setIsPaymentMethod(selectedSettlement);
  };

  const handleFrequencyMethod = (uiValue) => {
    const apiValue = FREQUENCY_MAP[uiValue] || uiValue.toLowerCase();
    handleSubmit("frequency", apiValue);
    setFrequencyMethod(apiValue);
  };

  const handleConfidentialMethod = (selectedSettlement) => {
    setConfidentialMethodFilter(selectedSettlement);
  };

  const handleAction = async () => {
    try {
      setBeneScheduleLoading(true);

      let queryParams1 = {
        page_no: currentPage,
        page_item_count: pageSize,
      };

      const addParamsBasedOnSelection = () => {
        if (frequencyMethod !== "") {
          queryParams1.frequency = frequencyMethod;
        }

        if (currentStatus) {
          if (currentStatus === "Require approval") {
            queryParams1.lifecycle_status = "pending";
          } else if (currentStatus === "Discarded") {
            queryParams1.lifecycle_status = "deleted";
          } else {
            queryParams1.lifecycle_status = currentStatus;
          }
        }

        if (initCategoryFilter !== null) {
          queryParams1.category_id = initCategoryFilter;
        }
        if (startDateFilter) {
          queryParams1.transaction_start_date = formatDate(startDateFilter);
        }

        if (endDateFilter) {
          queryParams1.transaction_end_date = formatDate(endDateFilter);
        }
        if (isPaymentMethod && isPaymentMethod !== "All") {
          queryParams1.payment_method = isPaymentMethod;
        }
        if (confidentialMethodFilter !== "") {
          queryParams1.confidential_transaction = confidentialMethodFilter;
        }

        if (txnAmountFilter !== "") {
          queryParams1.amount = txnAmountFilter;
        }

        if (destinationAccountName !== "") {
          queryParams1.beneficiary_account_id = destinationAccountName;
        }

        if (ownerAccountName !== "") {
          queryParams1.owner_account_id = ownerAccountName;
        }
        if (searchdata !== "") {
          queryParams1.scheduled_name = searchdata;
        }
        if (labelsFilter?.length && labelsFilter !== "Select labels") {
          queryParams1.labels = labelsFilter;
        }
      };

      addParamsBasedOnSelection();

      const response = await dispatch(
        scheduledBeneficiaryViewAll(queryParams1),
      );

      setMainData(response?.payload);
      setBeneScheduleLoading(true);
      const newData = response?.payload?.transactions || [];
      const fetchedLabels = response?.payload?.summary?.available_labels || [];
      setLabels((prev) =>
        Array.from(new Set([...(prev || []), ...fetchedLabels])),
      );
      setAccumulatedData(newData);
    } catch (error) {
      setAccumulatedData([]);
    } finally {
      setBeneScheduleLoading(false);
    }
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, [dispatch]);

  useEffect(() => {
    if (isLabelClicked) dispatch(disableSwitcher());
    else dispatch(enableSwitcher());
  }, [isLabelClicked]);

  useEffect(() => {
    handleAction();

    // let availableLabels = sessionStorage?.getItem(
    //   "scheduleBeneficiaryTxnLabels",
    // );
    // const parsedLabels = JSON?.parse(availableLabels);

    // let availableLabels = mainData?.summary?.available_labels;
    // setLabels(availableLabels || []);
  }, [
    markerData,
    currentPage,
    pageSize,
    isPaymentMethod,
    ownerAccountName,
    currentStatus,
    startDateFilter,
    destinationAccountName,
    initCategoryFilter,
    frequencyMethod,
    endDateFilter,
    confidentialMethodFilter,
    txnAmountFilter,
    searchdata,
    labelsFilter,
  ]);

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      isPaymentMethod !== "" ||
        frequencyMethod !== "" ||
        confidentialMethodFilter !== "" ||
        searchdata !== "" ||
        initCategoryFilter !== "" ||
        startDateFilter ||
        endDateFilter ||
        txnAmountFilter !== "" ||
        destinationAccountName !== "" ||
        ownerAccountName !== "" ||
        !!labelsFilter?.length,
    );
  };
  useEffect(() => {
    updateIsFilterApplied();
  }, [
    frequencyMethod,
    isPaymentMethod,
    confidentialMethodFilter,
    initCategoryFilter,
    startDateFilter,
    endDateFilter,
    txnAmountFilter,
    searchdata,
    destinationAccountName,
    ownerAccountName,
    labelsFilter,
  ]);

  const statuses = [
    "approved",
    "Require approval",
    "pending",
    "rejected",
    "Discarded",
  ];

  const filteredStatuses = statuses.filter((status) => {
    const hasAdmin = services?.includes("Admin");
    const hasABeneficiary = services?.includes("ABeneficiaryTxn");
    const hasCBeneficiary = services?.includes("CBeneficiaryTxn");

    const beneficiaryTxn =
      hasCBeneficiary &&
      !hasABeneficiary &&
      !hasAdmin &&
      status === "Require approval";

    const beneScheduleTxn =
      hasABeneficiary && !hasCBeneficiary && !hasAdmin && status === "pending";

    if (beneficiaryTxn) {
      return false;
    }

    if (beneScheduleTxn) {
      return false;
    }

    if (hasAdmin && hasABeneficiary && hasCBeneficiary) {
      return true;
    }

    return true;
  });

  const handleSubmit = (key, value) => {
    if (!isPopupMode) {
      handleSearchParams(key, value);
    }
  };

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
      });
    }
  }, [currentPage, accumulatedData]);

  const handleClearAllParams = () => {
    handleClearSearchParam();
    setSearchData("");
    setFrequencyMethod("");
    handleClearSearchParam();

    setStartDate(null);
    setStartDateFilter("");
    setEndDate(null);
    setEndDateFilter("");
    !isCreateFlow && setOwnerAccountName("");

    type !== "category" && setInitCategoryFilter("");
    !isCreateFlow && setIsPaymentMethod("");

    !isCreateFlow && setTxnAmountFilter("");

    !isCreateFlow && type !== "confidential" && setConfidentialMethodFilter("");
    !isCreateFlow && type !== "confidential" && setConfidentialMethod("");

    type !== "history" &&
      type !== "confidential" &&
      setTxnPayLoad((prev) => ({
        ...prev,
        bankAccountNo: "",
      }));
    if (type !== "ScheduleAccBeneAcc") {
      if (type !== "history" && type !== "confidential") {
        !isCreateFlow && setDestinationAccountName("");
      }
      setCurrentStatus("");
    }
    if (type !== "labelsFlow") {
      setFilterLabels([]);
    }
  };

  return (
    <>
      <>{RestrictedActionPopup}</>
      <div
        className={`overflow-y-hidden ${type === "ScheduleAccBeneAcc" || isCreateFlow ? "relative h-full overflow-x-hidden" : " h-full-height"} flex flex-col bg-primary-bg ${isPopup ? "h-height-full" : !accumulatedData?.length ? "" : ""}`}
      >
        {!beneScheduleLoading &&
          accumulatedData?.length > GlobalConfiguration.lengthCheckZero && (
            <div
              className={`w-width-full  z-z-index-modal ${type === "ScheduleAccBeneAcc" || "history" ? " absolute" : "fixed h-pagination-height"} ${showInnerSearchBar && "pointer-events-none"} ${
                isPopup
                  ? "w-width-full bottom-bottom-base  Qsmd:rounded-b-border-radius-md"
                  : "bottom-bottom-base"
              }
              ${type === "scheduleAcc" ? "h-auto Qmd:h-status_all_height" : "h-pagination-height"}
              ${type === "scheduleAcc" ? "block" : `block  ${type === "scheduleAcc" ? "rounded-b-border-radius-md" : ""}`}`}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop bg-opacity-light-opacity w-full h-full z-z-index-header"></div>
              )}
              <PaginationComponent
                handleSelect={handleSelect}
                selectedValue={selectedValue}
                data={mainData}
                pageSize={pageSize}
                dropdownOptions={dropdownOptions}
                handlePagination={handlePagination}
                currentPage={currentPage}
                payload={payload}
                setIsOpen={setIsOpen}
                type={type === "scheduleAcc" ? "scheduleAcc" : ""}
                typePopup={!isCreateFlow && isPopup}
              />
            </div>
          )}

        {isLabelPopupOpen && (
          <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
            <CommonAssignLabelPopup
              headerTitle="Assign/unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated schedules."
              closehandleFunction={handleCloseTxn}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={labelTransactions}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={labelTransactions}
              onClose={handleCloseTxn}
              loading={beneScheduleLoading}
              setLoading={setBeneScheduleLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
            />
          </div>
        )}

        <div
          className={`bg-primary-nav ${isPopup ? "" : type === "ScheduleAccBeneAcc" || isCreateFlow ? "" : "Qsmd:h-navbar-breadcrumb-height "}`}
        ></div>
        <div
          className={`bg-primary-nav flex flex-col items-center justify-center z-z-index-overlay relative`}
        >
          <div className="z-z-index-overlay w-full">
            <TopNavComponent
              topNavCtaBtn1Needed={isLabelClicked}
              topNavCtaBtn1Props={
                isLabelClicked
                  ? {
                      btnText:
                        Array.isArray(labelTransactions) &&
                        labelTransactions.length > 0
                          ? "Clear"
                          : "Cancel",
                      btnType: "button",
                      enabledBgColor: "var(--primary-nav-act)",
                      handleFunction: () => {
                        if (labelTransactions?.length > 0) {
                          setLabelTransactions([]);
                        } else {
                          setIsLabelClicked(false);
                        }
                      },
                      enabledTextColor: "var(--text-primary)",
                      isDisabled: false,
                      hoverOption: "white",
                    }
                  : undefined
              }
              topNavCtaBtn2Needed={isLabelClicked}
              topNavCtaBtn2Props={
                isLabelClicked
                  ? {
                      btnText: "Assign Labels",
                      btnType: "button",
                      enabledBgColor: labelTransactions?.length
                        ? "var(--text-primary)"
                        : "var(--text-disabled)",
                      handleFunction: (e) => {
                        e.stopPropagation();
                        if (!labelTransactions.length) return;
                        setIsLabelPopupOpen(true);
                      },
                      enabledTextColor: labelTransactions?.length
                        ? "var(--primary-bg)"
                        : "var(--text-primary)",
                      isDisabled: !labelTransactions?.length,
                      inActiveVariantNeeded: true,
                      hoverOption: labelTransactions?.length
                        ? "black"
                        : "white",
                    }
                  : undefined
              }
              isSelectionView={isLabelClicked}
              selectionText={`Schedules selected - ${selectedCount || GlobalConfiguration.lengthCheckZero}`}
              selectionBtnProps={
                isLabelClicked
                  ? {
                      btnText: `Select up to ${Number(selectedValue)}`,
                      enabledBgColor: `${
                        isAllSelected
                          ? "var(--positive-bg)"
                          : "var(--primary-nav-act)"
                      }`,
                      isDisabled:
                        beneScheduleLoading ||
                        selectableTransactions?.length ===
                          GlobalConfiguration.lengthCheckZero
                          ? true
                          : false,
                      handleFunction: (e) => {
                        if (beneScheduleLoading) return;
                        e.stopPropagation();
                        if (selectableTransactions?.length) {
                          handleSelectAll();
                        }
                      },
                      iconToBeAlign: "left",
                      enabledTextColor: "var(--text-primary)",
                      icon: isAllSelected
                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                        : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                      fullWidthRequired: false,
                      hoverOption: `${labelTransactions?.length ? "black" : "white"}`,
                    }
                  : undefined
              }
              assignLabelProps={
                !isLabelClicked
                  ? {
                      isDisabled:
                        isPopup ||
                        type === "ScheduleAccBeneAcc" ||
                        !accumulatedData?.length,
                      enabledBgColor: "var(--primary-bg)",
                      handleFunction: () => {
                        if (isPopup || type === "ScheduleAccBeneAcc") {
                          actionRestricted();
                          return;
                        }
                        if (!accumulatedData?.length) return;
                        if (
                          services?.includes("ALabel") &&
                          services?.includes("RLabel")
                        ) {
                          setIsLabelClicked((prev) => {
                            if (prev) setLabelTransactions([]);
                            return !prev;
                          });
                        }
                      },
                      hoverOption: "white",
                      disabledBgColor: "var(--primary-bg)",
                      title:
                        "Labels will be used to generate statistics for the associated schedules.",
                    }
                  : undefined
              }
              direction={direction}
              filteredSearchProps={{
                setShowInnerSearchBar: setShowInnerSearchBar,
                showSearchBar: true,
                isSearchDisabled: beneScheduleLoading,
                onSearchInput: handleSearch,
                searchText: searchUserTextDebounce,
                searchPlaceholder: "Search schedule beneficiary transaction",
                filterPlaceholder: "Schedule name",
                filterItems: [
                  {
                    name: "Search",
                    isMulti: false,
                    value: searchdata,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("search", val);
                      setSearchData(val);
                    },
                    isDropdown: false,
                    isDisabled: beneScheduleLoading,
                  },
                  {
                    name: "Owner account",
                    short_name: "Own A/c",
                    isMulti: false,
                    value: ownerAccountName,
                    displayValue: standardAccountNumberFormat(
                      accountNumber,
                      true,
                    ),
                    setValue: (val) => {
                      handleSubmit("sourceAcc", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setOwnerAccountName(val);
                    },
                    setDisplayValue: setAccountNumber,
                    valueType: "string",
                    isDropdown: true,
                    isDisabled: beneScheduleLoading || isCreateFlow,
                  },
                  {
                    name: "Beneficiary account",
                    short_name: "Bene. Acc",
                    isMulti: false,
                    value: destinationAccountName,
                    displayValue:
                      accountName
                        ?.toLowerCase()
                        .split(" ")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() + word.slice(1),
                        )
                        .join(" ") ||
                      accountNameValue
                        ?.toLowerCase()
                        .split(" ")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() + word.slice(1),
                        )
                        .join(" "),
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("beneAcc", val);
                      setDestinationAccountName(val);
                    },
                    setDisplayValue: (val) => {
                      setAccountName(val);
                      setAccountNameValue(val);
                    },
                    isDropdown: true,
                    valueType: "string",
                    isDisabled: beneScheduleLoading
                      ? true
                      : (isCreateFlow && dupFilters.beneficiary_account_id) ||
                        type === "history" ||
                        type === "scheduleAcc" ||
                        type === "confidential" ||
                        type === "ScheduleAccBeneAcc",
                  },
                  {
                    name: "Category",
                    valueType: "string",
                    short_name: "Cat",
                    isMulti: false,
                    value: initCategoryFilter,
                    displayValue: displayCategory,
                    setValue: (val) => {
                      const c =
                        categories.filter((x) => x.id === val)[0]?.name ?? "";
                      setDisplayCategory(c);
                      handleSubmit("category", val);
                      handleSubmit("dispCategory", c);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setInitCategoryFilter(val);
                    },
                    isDropdown: true,
                    isDisabled: beneScheduleLoading
                      ? true
                      : type === "category",
                  },
                  {
                    name: "Labels",
                    short_name: "Lab",
                    isMulti: true,
                    value: labelsFilter,
                    setValue: (val) => {
                      handleSubmit("label", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setFilterLabels(val);
                    },
                    isDropdown: true,
                    valueType: "string",
                    isDisabled: beneScheduleLoading || type === "labelsFlow",
                  },
                  {
                    name: "Amount",
                    short_name: "Amt - INR",
                    isMulti: false,
                    value: txnAmountFilter,
                    setValue: (val) => {
                      handleSubmit("amount", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setTxnAmountFilter(val);
                    },
                    displayValue: FormatAmount({
                      price: txnAmountFilter,
                    }),
                    isDropdown: false,
                    isDisabled: beneScheduleLoading || isCreateFlow,
                    valueType: "number",
                  },
                ],
                filters: [
                  {
                    name: "Approval status",
                    filterType: "dropdown",
                    variant: "single",
                    value: currentStatus,
                    options: filteredStatuses.map((status) => status),
                    dropdownPlaceHolder:
                      currentStatus === "deleted"
                        ? "Discard"
                        : currentStatus === "rejected"
                          ? "Rejected"
                          : "Select status",
                    isDisabled: type === "ScheduleAccBeneAcc" ?? false,
                    statusPop: true,
                    handleChange: (val) => {
                      handleSubmit("lifecycle", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setCurrentStatus(val);
                    },
                  },
                  {
                    name: "Frequency",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: [
                      "Once",
                      "Daily",
                      "Weekly",
                      "Fortnightly",
                      "Monthly",
                      "Quarterly",
                      "Half yearly",
                      "Yearly",
                    ],
                    searchPlaceholder: "Search",
                    dropdownPlaceHolder: "Select frequency",
                    value:
                      Object.keys(FREQUENCY_MAP).find(
                        (key) => FREQUENCY_MAP[key] === frequencyMethod,
                      ) || frequencyMethod,
                    isDisable: false,

                    handleChange: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleFrequencyMethod(val);
                    },
                  },
                  {
                    name: "Schedule start date",
                    filterType: "calender",
                    variant: "single",
                    size: "small",
                    value: startDateFilter,
                    startDate: startDate,
                    handleChange: (value) => {
                      handleSubmit("startDate", value);

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setStartDate(value);
                      setStartDateFilter(value);

                      if (endDate && new Date(value) > new Date(endDate)) {
                        setEndDate("");
                        setEndDateFilter("");
                        handleSubmit("endDate", "");
                      }
                    },
                    minDate: null,
                    maxDate: null,
                  },
                  {
                    name: "Show/hide confidential schedules",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: ["Show only confidential", "Hide confidential"],
                    searchPlaceholder: "Search",
                    isDisabled:
                      (isCreateFlow && dupFilters.confidential_transaction) ||
                      type === "confidential",
                    dropdownPlaceHolder:
                      confidentialMethod &&
                      confidentialMethod !== "Default (all schedules)"
                        ? confidentialMethod
                        : "Default (all schedules)",
                    value: confidentialMethodFilter,
                    handleChange: (val) => {
                      handleSubmit("confidential", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleConfidentialMethod(val);
                    },
                  },
                  {
                    name: "Payment method",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: ["NEFT", "RTGS"],
                    searchPlaceholder: "Search",
                    dropdownPlaceHolder: isPaymentMethod || "Select type",
                    value: isPaymentMethod,
                    dropdownType: "PaymentMethod",
                    isDisabled: isCreateFlow && dupFilters.payment_method,
                    handleChange: (val) => {
                      handleSubmit("paymentmethod", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handlePaymentMethod(val);
                    },
                  },
                  {
                    name: "Schedule end date",
                    filterType: "calender",
                    variant: "single",
                    size: "small",
                    value: endDateFilter,
                    startDate: endDate,
                    handleChange: (value) => {
                      handleSubmit("endDate", value);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setEndDate(value);
                      setEndDateFilter(value);

                      if (startDate && new Date(value) < new Date(startDate)) {
                        setStartDate("");
                        handleSubmit("startDate", "");
                        setStartDateFilter("");
                      }
                    },
                    minDate: startDateFilter || new Date(),
                    maxDate: null,
                  },
                ],

                isFilterClearAllDisabled:
                  isCreateFlow &&
                  isPaymentMethod !== "" &&
                  confidentialMethodFilter !== "" &&
                  !(
                    currentStatus !== "" ||
                    startDateFilter ||
                    endDateFilter ||
                    frequencyMethod?.length
                  )
                    ? true
                    : type === "ScheduleAccBeneAcc" &&
                        currentStatus !== "" &&
                        !(
                          isPaymentMethod !== "" ||
                          frequencyMethod?.length ||
                          (type !== "confidential" &&
                            confidentialMethodFilter !== "") ||
                          startDateFilter ||
                          endDateFilter ||
                          beneScheduleLoading
                        )
                      ? true
                      : !(
                          isPaymentMethod !== "" ||
                          frequencyMethod?.length ||
                          (type !== "confidential" &&
                            confidentialMethodFilter !== "") ||
                          startDateFilter ||
                          endDateFilter ||
                          currentStatus !== "" ||
                          beneScheduleLoading
                        ),

                isSearchClearAllDisabled:
                  type === "labelsFlow"
                    ? !(
                        searchdata !== "" ||
                        initCategoryFilter !== "" ||
                        destinationAccountName !== "" ||
                        txnAmountFilter !== "" ||
                        ownerAccountName !== "" ||
                        beneScheduleLoading
                      )
                    : isCreateFlow &&
                        dupFilters.payment_method &&
                        dupFilters.amount &&
                        dupFilters.confidential_transaction &&
                        dupFilters.beneficiary_account_id &&
                        dupFilters.owner_account_id &&
                        !(
                          searchdata !== "" ||
                          initCategoryFilter !== "" ||
                          labelsFilter?.length >
                            GlobalConfiguration.lengthCheckZero
                        )
                      ? true
                      : type === "ScheduleAccBeneAcc" &&
                          destinationAccountName !== "" &&
                          !(
                            searchdata !== "" ||
                            initCategoryFilter !== "" ||
                            txnAmountFilter !== "" ||
                            ownerAccountName !== "" ||
                            labelsFilter?.length >
                              GlobalConfiguration.lengthCheckZero
                          )
                        ? true
                        : !(
                              (type !== "category" &&
                                initCategoryFilter !== "") ||
                              (type !== "history" &&
                                type !== "confidential" &&
                                type !== "scheduleAcc" &&
                                type !== "ScheduleAccBeneAcc" &&
                                destinationAccountName !== "") ||
                              searchdata !== "" ||
                              txnAmountFilter !== "" ||
                              (type !== "history" &&
                                type !== "confidential" &&
                                ownerAccountName !== "") ||
                              labelsFilter?.length >
                                GlobalConfiguration.lengthCheckZero ||
                              beneScheduleLoading
                            )
                          ? true
                          : false,

                inputData: inputData,
                active: active,
                setActive: setActive,
                beneScheduleLoading: loadingData,
                setBeneScheduleLoading: setLoadingData,
                isShowFilter: true,
                loading: beneScheduleLoading,
                loadingData: loadingData,

                isSortDisabled: beneScheduleLoading,
                isFilterDisabled: beneScheduleLoading,
              }}
              BottomSubText={
                isLabelClicked
                  ? "Select schedules to apply labels. These labels will be used to generate statistics for the associated schedules."
                  : "Below are the schedules’ details. Approved schedules will generate transactions according to the specified frequency."
              }
              BottomSubTextVaraint="primary"
              ispagination={
                accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                  ? false
                  : true
              }
            />
          </div>
        </div>
        <div className="beneTxnViewAll_middle_section_container mx-auto webViewRejectAll"></div>
        <div
          className={`flex flex-col flex-1 relative items-center ${accumulatedData?.length > GlobalConfiguration.lengthCheckZero && !beneScheduleLoading && "mb-[var(--pagination-height)]"} overflow-hidden  ${!accumulatedData?.length && "justify-center"} `}
          style={{
            paddingTop:
              isFilterApplied && !accumulatedData.length && isPopup
                ? "var(--padding-md)"
                : isFilterApplied && !accumulatedData.length && isPopup
                  ? "var(--padding-md)"
                  : "",
          }}
        >
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop bg-opacity-light-opacity w-full h-full z-z-index-header"></div>
          )}
          <div
            className="flex flex-col items-center w-full z-z-index-base flex-1 h-height-full opacity-base-opacity"
            style={{
              pointerEvents: showInnerSearchBar ? "none" : "",
            }}
          >
            {beneScheduleLoading ? (
              <div className="loader-container m-auto justify-center items-center flex w-width-full h-full-height">
                <Loader />
              </div>
            ) : accumulatedData?.length >
              GlobalConfiguration?.lengthCheckZero ? (
              <div
                className={`flex flex-col min-h-height-base flex-1 w-width-full h-height-full overflow-y-auto scroll-py-top_md ${
                  type === "scheduleAcc" ? "overflow-scroll no-scrollbar" : ""
                } `}
                ref={scrollContainerRef}
                onScroll={handleScroll}
              >
                <ScheduleBeneficiaryTransactionViewAllCard
                  filterRef={scrollContainerRef}
                  hoverHeight={
                    GlobalConfiguration?.beneScheduleTxnCardHoverHeight
                  }
                  data={accumulatedData}
                  isCardHovered={isCardHovered}
                  setIsCardHovered={setIsCardHovered}
                  currentStatus={currentStatus}
                  onClose={handleCloseViewModal}
                  type={type}
                  isLabelClicked={isLabelClicked}
                  labelTransactions={labelTransactions}
                  setLabelTransactions={setLabelTransactions}
                  handleLabelSelect={handleLabelTransactionSelect}
                />
              </div>
            ) : accumulatedData?.length ===
              GlobalConfiguration?.lengthCheckZero ? (
              <div
                className={
                  showInnerSearchBar
                    ? `h-height-full flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl gap-gap-sm`
                    : isPaymentMethod !== "" ||
                        frequencyMethod !== "" ||
                        confidentialMethodFilter !== "" ||
                        initCategoryFilter ||
                        startDateFilter ||
                        endDateFilter ||
                        txnAmountFilter !== "" ||
                        labelsFilter?.length
                      ? `h-height-full flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl gap-gap-sm`
                      : "flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl h-height-full gap-gap-sm"
                }
              >
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className={"w-graphic-width-md h-graphic-rectangle-height-md"}
                />
                <p className={"text-font-sm text-text-primary items-center"}>
                  No data found.
                </p>

                <div
                  style={{
                    display:
                      isFilterApplied ||
                      isPaymentMethod !== "" ||
                      frequencyMethod?.length ||
                      confidentialMethodFilter !== "" ||
                      initCategoryFilter?.length ||
                      startDateFilter?.length ||
                      endDateFilter?.length ||
                      txnAmountFilter?.length ||
                      currentStatus !== "" ||
                      searchdata?.length ||
                      destinationAccountName?.length ||
                      labelsFilter?.length ||
                      startDate ||
                      endDate
                        ? "flex"
                        : "none",
                  }}
                >
                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText="Clear parameters"
                    enabledTextColor="var(--text-primary)"
                    hoverOption="white"
                    handleFunction={handleClearAllParams}
                    buttonRef={clearButtonRef}
                  />
                </div>
              </div>
            ) : (
              <div
                className="flex flex-col items-center justify-center m-auto h-height-full"
                style={{
                  opacity: showInnerSearchBar
                    ? "var(--light-opacity)"
                    : "var(--base-opacity)",
                }}
              >
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className={"w-graphic-width-md h-graphic-rectangle-height-md"}
                />
                <p className={"text-font-sm text-text-primary items-center"}>
                  No data found.
                </p>
                <div
                  style={{
                    display:
                      isFilterApplied ||
                      isPaymentMethod !== "" ||
                      frequencyMethod?.length ||
                      confidentialMethodFilter !== "" ||
                      initCategoryFilter?.length ||
                      startDateFilter?.length ||
                      endDateFilter?.length ||
                      txnAmountFilter?.length ||
                      currentStatus !== "" ||
                      searchdata?.length ||
                      destinationAccountName?.length ||
                      labelsFilter?.length ||
                      startDate ||
                      endDate
                        ? "flex"
                        : "none",
                  }}
                >
                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText="Clear parameters"
                    enabledTextColor="var(--text-primary)"
                    hoverOption="white"
                    handleFunction={handleClearAllParams}
                    buttonRef={clearButtonRef}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default ScheduleBeneficiaryTransactionViewSchedules;
